module.exports = __webpack_public_path__ + "assets/img/idcard-badge.a1107c71.png";